import type { GridList } from "@repo/ui";

import { Complaint } from "@repo/models";

import type { ComplaintsFilter } from "../models/complaint";
import type { ComplaintOrIncidentOption } from "../models/ComplaintOrIncidentOption";
import type { ComplaintSource } from "../models/ComplaintSource";
import type { ComplaintType } from "../models/ComplaintType";
import type { ReportingTag } from "../models/ReportingTag";
import type { User } from "../models/User";

import { BaseController } from "./baseController";
import { BaseGridApi } from "./baseGridApi";

export const controller = "CustomerIncidents";
const gridFiltersController = "GridFilters";

export default class ComplaintsApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);
	static GetGridFilters = BaseController.GetFn(gridFiltersController);

	/** Loads all complaints matching filters */
	static getComplaints(filter: ComplaintsFilter) {
		return ComplaintsApi.Get<GridList<Complaint>>("GetComplaints", filter);
	}

	/** Gets complaint types for dropdown */
	static getComplaintTypes() {
		return ComplaintsApi.Get<ComplaintType[]>("GetComplaintTypes");
	}

	/** Gets complaint sources for dropdown */
	static getComplaintSources() {
		return ComplaintsApi.Get<ComplaintSource[]>("GetComplaintSources");
	}

	/** Gets users for QA Analyst dropdown */
	static getUsers() {
		return ComplaintsApi.GetGridFilters<User[]>("GetUsers");
	}

	/** Gets reporting tags for dropdown */
	static getReportingTags(branchIds?: number[]) {
		return ComplaintsApi.Get<ReportingTag[]>("GetReportingTags", { branchIds });
	}

	/** Gets complaint or incident options for dropdown */
	static getComplaintOrIncident() {
		return ComplaintsApi.Get<ComplaintOrIncidentOption[]>("GetComplaintOrIncident");
	}

	/** Deletes a complaint (POST with complaint in body) */
	static deleteComplaint(complaint: Complaint) {
		return ComplaintsApi.Post("Delete", complaint);
	}

	static settings() {
		return ComplaintsApi.Get<IComplaintSettings>("Settings");
	}

	/** Loads saved grid settings for complaints */
	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "Customer Incidents");
	}

	/** Saves grid settings for complaints. Pass empty string to clear. */
	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "Customer Incidents", settingsJson);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "CustomerIncident");
	}
}

interface IComplaintSettings {
	isAdmin: boolean;
	showCommissionComplaint: boolean;
}
